import { Tooltip, Typography } from "antd";
import styled from "styled-components";

export function ScenarioHeader({ projectName }) {
  return (
    <ProjectTitleWrapper>
      <Tooltip title={projectName}>
        <Typography.Title
          level={4}
          style={{
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
          {projectName}
        </Typography.Title>
      </Tooltip>
    </ProjectTitleWrapper>
  );
}

const ProjectTitleWrapper = styled.div`
  grid-column: 1 / -1;
  padding: 5px 10px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
